"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _componentUtils = _interopRequireDefault(require("../component-utils"));

var _attach = _interopRequireDefault(require("../attach"));

var _flexBreak = _interopRequireDefault(require("../flex-break"));

var _utils = _interopRequireDefault(require("../utils"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Use MSON React Component instead?
var Field = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(Field, _React$PureComponent);

  var _super = _createSuper(Field);

  function Field() {
    (0, _classCallCheck2.default)(this, Field);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Field, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          component = _this$props.component,
          hidden = _this$props.hidden,
          block = _this$props.block,
          accessEditable = _this$props.accessEditable,
          didCreate = _this$props.didCreate,
          noBlock = _this$props.noBlock,
          disabled = _this$props.disabled; // Don't show the component until didCreate is true as we may need to wait for fields to be
      // hidden or otherwise modified by listeners

      if (hidden || !didCreate) {
        return null;
      } else if (component.getClassName() === 'Field') {
        // Prevent an infinite loop caused by trying to render component=Field
        return null;
      } else {
        // Get corresponding UI component
        var _Field = _componentUtils.default.getUIComponent(component); // Note: we use React.Fragment over a span as spans can cause issues with the flexbox layout
        // when displaying a nested form


        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Field, (0, _extends2.default)({
          component: component,
          accessEditable: accessEditable,
          block: block
        }, _utils.default.getIfDefined({
          disabled
        }))), !noBlock && block ? /*#__PURE__*/_react.default.createElement(_flexBreak.default, null) : null);
      }
    }
  }]);
  return Field;
}(_react.default.PureComponent);

var _default = (0, _attach.default)(['hidden', 'block', 'didCreate'])(Field);

exports.default = _default;